<template>
  <v-tooltip :disabled="tooltip ? tooltipDisabled : true" bottom color="#2C2C2C">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="base-tooltip"
        :class="[maxContent ? 'base-tooltip--content' : '', customClass ? customClass : '']"
        v-bind="attrs"
        v-on="on"
      >
        <slot></slot>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BaseTooltip',
  props: {
    tooltip: String,
    tooltipDisabled: Boolean,
    maxContent: Boolean,
    customClass: String,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.base-tooltip {
  line-height: 1;
  &--content {
    width: max-content;
  }
}
</style>
